/*
  GrowKids — visor de páginas a pantalla completa (compartido).
  Nació dentro de la sección "Avance" (digital-pdp-paginas) y se extrajo aquí
  para que cualquier sección de la ficha abra sus páginas con el MISMO visor:
  página a sangre sobre negro al 90 %, zoom (rueda, lupas, clic, teclado),
  arrastre para desplazarse, deslizar para pasar de página y controles que
  aparecen con el cursor.

  Uso:
    window.GKPageViewer.open(pages, index, { opener, onClose })
      pages   → [{ href: 'url de la imagen grande', alt: 'texto' }, …]
      index   → página con la que se abre (0 = primera)
      opener  → elemento que recibe el foco al cerrar (opcional)
      onClose → function (paginaActual) {…} (opcional; reemplaza el foco)

  El diálogo se crea una sola vez, al primer uso, y se reutiliza.
*/
(function () {
  if (window.GKPageViewer) return;

  var ICON = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    out: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20.5 20.5-4-4M8 11h6"/></svg>',
    in: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20.5 20.5-4-4M8 11h6M11 8v6"/></svg>'
  };

  var lb, stage, full, elZoom, btnIn, btnOut, dCounter;
  var pages = [];
  var opts = {};
  var n = 0;
  var STEPS = [1, 1.25, 1.5, 2, 2.5, 3, 4];
  var current = 0;
  var z = 1, x = 0, y = 0;
  var maxZoom = 3;            // se recalcula con la resolución real
  var bodyOverflow = '';
  var animTimer = null;
  var EDGE_GRACE = 1000;      // lo que la flecha sobrevive tras dejar su borde
  var edgeTimers = { prev: null, next: null };

  function build() {
    lb = document.createElement('dialog');
    lb.className = 'gkv';
    lb.setAttribute('aria-label', 'Vista ampliada de las páginas');
    lb.innerHTML =
      '<div class="gkv__stage" data-gkv-stage><img data-gkv-full alt="" draggable="false" width="1100" height="1556"></div>' +
      '<button type="button" class="gkv__icon gkv__close" data-gkv-close aria-label="Cerrar (Esc)">' + ICON.close + '</button>' +
      '<button type="button" class="gkv__icon gkv__side gkv__side--prev" data-gkv-prev aria-label="Página anterior">' + ICON.prev + '</button>' +
      '<button type="button" class="gkv__icon gkv__side gkv__side--next" data-gkv-next aria-label="Página siguiente">' + ICON.next + '</button>' +
      '<span class="gkv__pill gkv__pill--count" data-gkv-count aria-live="polite" aria-atomic="true"></span>' +
      '<div class="gkv__pill gkv__zoombar">' +
        '<button type="button" class="gkv__icon" data-gkv-zoomout aria-label="Alejar">' + ICON.out + '</button>' +
        '<span class="gkv__readout" data-gkv-zoomlevel aria-live="polite" aria-atomic="true">100%</span>' +
        '<button type="button" class="gkv__icon" data-gkv-zoomin aria-label="Acercar">' + ICON.in + '</button>' +
      '</div>';
    document.body.appendChild(lb);

    stage = lb.querySelector('[data-gkv-stage]');
    full = lb.querySelector('[data-gkv-full]');
    elZoom = lb.querySelector('[data-gkv-zoomlevel]');
    btnIn = lb.querySelector('[data-gkv-zoomin]');
    btnOut = lb.querySelector('[data-gkv-zoomout]');
    dCounter = lb.querySelector('[data-gkv-count]');

    full.addEventListener('load', function () {
      lb.classList.add('is-ready');
      computeMaxZoom();
    });

    // ---- controles que acompañan al cursor
    lb.addEventListener('pointermove', function (event) {
      showChrome();
      if (event.pointerType !== 'touch') trackEdges(event.clientX);
    }, { passive: true });
    ['pointerdown', 'keydown', 'wheel'].forEach(function (type) {
      lb.addEventListener(type, showChrome, { passive: true });
    });
    // el cursor abandona la ventana (o la pestaña pierde el foco)
    document.addEventListener('mouseleave', function () { if (lb.open) hideChrome(); });
    document.addEventListener('mouseenter', function () { if (lb.open) showChrome(); });
    window.addEventListener('blur', function () { if (lb.open) hideChrome(); });

    // ---- cerrar
    lb.querySelector('[data-gkv-close]').addEventListener('click', function () { lb.close(); });
    lb.addEventListener('close', function () {
      clearTimeout(edgeTimers.prev);
      clearTimeout(edgeTimers.next);
      document.body.style.overflow = bodyOverflow;
      if (typeof opts.onClose === 'function') {
        opts.onClose(current);
      } else if (opts.opener && opts.opener.focus) {
        opts.opener.focus({ preventScroll: true });
      }
    });

    // ---- navegación entre páginas
    lb.querySelector('[data-gkv-prev]').addEventListener('click', function () { showPage(current - 1); });
    lb.querySelector('[data-gkv-next]').addEventListener('click', function () { showPage(current + 1); });

    // ---- zoom
    btnIn.addEventListener('click', function () { stepZoom(1); });
    btnOut.addEventListener('click', function () { stepZoom(-1); });
    stage.addEventListener('wheel', function (event) {
      event.preventDefault();
      var c = centerOf(event);
      instant(true);
      setZoom(z * (event.deltaY < 0 ? 1.12 : 1 / 1.12), c.x, c.y);
    }, { passive: false });

    // ---- pan arrastrando (sin teclas modificadoras)
    var dragging = false, moved = false, sx = 0, sy = 0, ox = 0, oy = 0;
    var swipeX = null, swipeY = 0, touchInput = false;
    // sin esto el navegador arrastra el ARCHIVO de la imagen (cursor de
    // "prohibido") en lugar de desplazarla dentro del visor
    stage.addEventListener('dragstart', function (event) { event.preventDefault(); });
    stage.addEventListener('pointerdown', function (event) {
      if (event.button > 0) return;
      event.preventDefault();
      touchInput = event.pointerType === 'touch';
      moved = false;
      if (z <= 1.001) {
        // sin zoom, el arrastre lateral pasa de página
        swipeX = event.clientX;
        swipeY = event.clientY;
        return;
      }
      dragging = true;
      sx = event.clientX; sy = event.clientY; ox = x; oy = y;
      instant(false);
      stage.classList.add('is-instant', 'is-panning');
      if (stage.setPointerCapture) stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var dx = event.clientX - sx, dy = event.clientY - sy;
      if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
      x = ox + dx; y = oy + dy;
      apply();
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      stage.classList.remove('is-panning', 'is-instant');
    }
    stage.addEventListener('pointerup', function (event) {
      if (swipeX !== null) {
        var dx = event.clientX - swipeX;
        var dy = event.clientY - swipeY;
        swipeX = null;
        if (n > 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          moved = true;                       // que el click no reabra el zoom
          showPage(current + (dx < 0 ? 1 : -1));
          return;
        }
      }
      endDrag();
    });
    stage.addEventListener('pointercancel', function () { swipeX = null; endDrag(); });

    // clic sobre la página alterna zoom; clic en el fondo cierra
    stage.addEventListener('click', function (event) {
      if (moved) { moved = false; return; }
      if (event.target !== full) { lb.close(); return; }
      // al tacto un toque muestra u oculta los controles (el zoom va por
      // las lupas); con ratón el clic acerca sobre el punto señalado
      if (touchInput) {
        if (lb.classList.contains('is-chrome')) hideChrome();
        else showChrome();
        return;
      }
      var c = centerOf(event);
      if (z > 1.001) setZoom(1);
      else setZoom(Math.min(2, maxZoom), c.x, c.y);
    });

    // ---- teclado
    lb.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'ArrowLeft') { event.preventDefault(); showPage(current - 1); }
      else if (key === 'ArrowRight') { event.preventDefault(); showPage(current + 1); }
      else if (key === '+' || key === '=') { event.preventDefault(); stepZoom(1); }
      else if (key === '-' || key === '_') { event.preventDefault(); stepZoom(-1); }
      else if (key === '0') { event.preventDefault(); setZoom(1); }
    });

    window.addEventListener('resize', function () { if (lb.open) { computeMaxZoom(); apply(); } }, { passive: true });
  }

  function showChrome() {
    lb.classList.add('is-chrome');
    lb.classList.remove('is-away');
  }
  function hideChrome() {
    lb.classList.remove('is-chrome');
    lb.classList.add('is-away');
    clearTimeout(edgeTimers.prev);
    clearTimeout(edgeTimers.next);
    lb.classList.remove('show-prev', 'show-next');
  }
  // la flecha aparece al rondar su borde y se retira un segundo después
  function setEdge(side, near) {
    var cls = 'show-' + side;
    clearTimeout(edgeTimers[side]);
    if (near) {
      lb.classList.add(cls);
    } else if (lb.classList.contains(cls)) {
      edgeTimers[side] = setTimeout(function () { lb.classList.remove(cls); }, EDGE_GRACE);
    }
  }
  function trackEdges(clientX) {
    if (n < 2) return;
    var band = Math.max(160, window.innerWidth * 0.18);
    setEdge('prev', clientX <= band);
    setEdge('next', clientX >= window.innerWidth - band);
  }

  // 100% = la página completa en pantalla. El techo se estira hasta el
  // tamaño real de la imagen (más allá solo se vería interpolada), pero
  // nunca por debajo de 250%: hay que poder acercarse a leer aunque la
  // página venga en baja resolución.
  function computeMaxZoom() {
    var natural = full.naturalWidth || 0;
    var shownW = full.offsetWidth || 1;
    if (!natural) return;
    maxZoom = Math.max(2.5, Math.min(4, natural / shownW));
    if (z > maxZoom) setZoom(maxZoom);
    else apply();
  }

  function clampPan() {
    var s = stage.getBoundingClientRect();
    var w = full.offsetWidth * z;
    var h = full.offsetHeight * z;
    var mx = Math.max(0, (w - s.width) / 2);
    var my = Math.max(0, (h - s.height) / 2);
    x = Math.min(mx, Math.max(-mx, x));
    y = Math.min(my, Math.max(-my, y));
  }

  function apply() {
    clampPan();
    full.style.setProperty('--gkv-x', x + 'px');
    full.style.setProperty('--gkv-y', y + 'px');
    full.style.setProperty('--gkv-z', z);
    elZoom.textContent = Math.round(z * 100) + '%';
    stage.classList.toggle('can-pan', z > 1.001);
    btnOut.disabled = z <= 1.001;
    btnIn.disabled = z >= maxZoom - 0.001;
  }

  // cx/cy: punto sobre el que se acerca, relativo al centro del escenario
  function setZoom(next, cx, cy) {
    next = Math.min(maxZoom, Math.max(1, next));
    if (cx === undefined) { cx = 0; cy = 0; }
    var ratio = next / z;
    x = cx - (cx - x) * ratio;
    y = cy - (cy - y) * ratio;
    z = next;
    if (z <= 1.001) { x = 0; y = 0; }
    apply();
  }

  function stepZoom(dir) {
    var target = dir > 0 ? maxZoom : 1;
    var i;
    if (dir > 0) {
      for (i = 0; i < STEPS.length; i++) {
        if (STEPS[i] > z + 0.001 && STEPS[i] <= maxZoom) { target = STEPS[i]; break; }
      }
    } else {
      for (i = STEPS.length - 1; i >= 0; i--) {
        if (STEPS[i] < z - 0.001) { target = STEPS[i]; break; }
      }
    }
    setZoom(target);
  }

  // el zoom animado se corta mientras se arrastra o se usa la rueda
  function instant(on) {
    clearTimeout(animTimer);
    if (on) {
      stage.classList.add('is-instant');
      animTimer = setTimeout(function () { stage.classList.remove('is-instant'); }, 180);
    } else {
      stage.classList.remove('is-instant');
    }
  }

  function centerOf(event) {
    var s = stage.getBoundingClientRect();
    return { x: event.clientX - (s.left + s.width / 2), y: event.clientY - (s.top + s.height / 2) };
  }

  function showPage(i) {
    current = ((i % n) + n) % n;
    z = 1; x = 0; y = 0;
    lb.classList.remove('is-ready');
    full.src = pages[current].href;
    full.alt = pages[current].alt || '';
    dCounter.textContent = (current + 1) + ' / ' + n;
    apply();
    // las vecinas quedan en caché para que pasar página sea instantáneo
    if (n > 1) {
      [current + 1, current - 1].forEach(function (j) {
        var img = new Image();
        img.src = pages[((j % n) + n) % n].href;
      });
    }
  }

  window.GKPageViewer = {
    open: function (list, index, options) {
      if (!list || !list.length) return false;
      if (!lb) build();
      if (!lb.showModal) return false;
      pages = list;
      n = list.length;
      opts = options || {};
      lb.classList.toggle('is-single', n < 2);
      showPage(index || 0);
      bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      lb.showModal();
      showChrome();
      return true;
    }
  };

  /* Enlaces declarativos: cualquier contenedor con [data-gkv-group] cuyos
     enlaces lleven [data-gkv-open] abre el visor con todas las páginas del
     grupo (en orden de aparición, sin repetir la misma imagen). Sin JS el
     enlace sigue abriendo la imagen, así que nunca queda un clic muerto. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-gkv-open]');
    if (!link || event.defaultPrevented) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    var group = link.closest('[data-gkv-group]');
    var links = group ? [].slice.call(group.querySelectorAll('[data-gkv-open]')) : [link];
    var seen = {};
    var list = [];
    var start = 0;
    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (seen[href] === undefined) {
        seen[href] = list.length;
        list.push({ href: href, alt: a.getAttribute('data-gkv-alt') || (a.querySelector('img') || {}).alt || '' });
      }
    });
    start = seen[link.getAttribute('href')] || 0;
    if (window.GKPageViewer.open(list, start, { opener: link })) event.preventDefault();
  });
})();
